import React from "react";
import FormDocumentPicturePreview from "../../../../../../components/common/PL/PicturePreview/FormDocumentPicturePreview";

type ObservationsImagePreviewProps = {
  name: string;
  label?: string;
  fileName?: string;
  previewHeight?: number | string;
  placeholderHeight?: number | string;
  backgroundColor?: string;
  borderStyle?: "normal" | "dashed";
  iconVariant?: "default" | "circularImage";
  allowClear?: boolean;
  readOnly?: boolean;
};

const ObservationsImagePreview: React.FC<ObservationsImagePreviewProps> = ({
  name,
  label = "Foto de observaciones",
  fileName,
  previewHeight = 250,
  placeholderHeight = 150,
  backgroundColor = "#F8FAFC",
  borderStyle = "dashed",
  iconVariant = "circularImage",
  allowClear = true,
  readOnly = false,
}) => {
  return (
    <div className="observationsImagePreviewContainer">
      {label && <label className="observationsImageLabel">{label}</label>}
      <FormDocumentPicturePreview
        name={name}
        label="Foto de observaciones"
        fileName={fileName}
        previewHeight={previewHeight}
        placeholderHeight={placeholderHeight}
        backgroundColor={backgroundColor}
        borderStyle={borderStyle}
        iconVariant={iconVariant}
        allowClear={allowClear}
        allowImageViewer
        readOnly={readOnly}
      />
    </div>
  );
};

export default ObservationsImagePreview;
